module.exports = __webpack_public_path__ + "static/media/blog-2.b9719ed4.png";